module.exports = __webpack_public_path__ + "b047199e049272be1332a3c049be6187.fbx";